export type ConnectionTestPayload = {
	readonly succeeded: boolean;
	readonly message: string;
	readonly testedAt: string;
};

export type ConnectionTestedAction = {
	type: 'CONNECTION_TESTED';
	payload: ConnectionTestPayload;
	accountId: number;
};

export default (payload: ConnectionTestPayload, accountId: number): ConnectionTestedAction => ({
	type: 'CONNECTION_TESTED',
	payload,
	accountId,
});
